import graphql__2a61a2d174d13de049a8 from "./__generated__/AppOrganizationSelectDestinationInputTransferMutation.graphql.ts";import { Alert, Button, Select } from '@portal/components'
import { graphql } from 'babel-plugin-relay/macro'
import React, { useState } from 'react'
import { useMutation } from 'react-relay/hooks'

import { AppOrganizationSelectDestinationInputTransferMutation } from './__generated__/AppOrganizationSelectDestinationInputTransferMutation.graphql'
import { TransferAppDestinationSelectorFragment_organization$data } from './__generated__/TransferAppDestinationSelectorFragment_organization.graphql'
import TransferAppConfirmationModal from './TransferAppConfirmationModal'

const transferMutation = graphql__2a61a2d174d13de049a8

type Props = {
  /** App ID */
  appId: string
  /** List of user organizations */
  organizations: readonly TransferAppDestinationSelectorFragment_organization$data[]
}

const AppOrganizationSelectDestinationInput: React.FC<Props> = ({
  appId,
  organizations,
}) => {
  const [transferApp, isTransferringApp] =
    useMutation<AppOrganizationSelectDestinationInputTransferMutation>(
      transferMutation,
    )
  const [destinationOrganization, setDestinationOrganization] =
    useState<TransferAppDestinationSelectorFragment_organization$data | null>(
      null,
    )
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)
  const [transferError, setTransferError] = useState<Error>()

  const handleTransferClicked = () => {
    setTransferError(undefined)
    setIsConfirmationOpen(true)
  }

  const handleConfirmationClosed = (confirmTransfer: boolean) => {
    if (confirmTransfer && destinationOrganization) {
      transferApp({
        variables: { appId, organizationId: destinationOrganization.id },
        onCompleted: () => {
          setIsConfirmationOpen(false)
        },
        onError: (err) => {
          setTransferError(err)
        },
      })
    } else {
      setIsConfirmationOpen(false)
    }
  }

  return (
    <>
      {!!transferError && (
        <Alert
          autoDismiss={false}
          variant="danger"
        >{`Could not create the app transfer request: ${transferError.message}`}</Alert>
      )}
      <TransferAppConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={handleConfirmationClosed}
        appId={appId}
        destination={destinationOrganization?.slug || ''}
        isProcessing={isTransferringApp}
      />

      <Select
        id="organizationSelect"
        label="Organization"
        options={(organizations || []).map((org) => ({
          value: org.id || '',
          label: (
            <div className="flex items-center space-x-3">
              <div className="relative rounded-full">
                <img
                  className="h-6 w-6 rounded-full object-cover"
                  alt={`${org.name} avatar`}
                  src={org.imageUrl || ''}
                />
              </div>
              <div>{org.name}</div>
            </div>
          ),
        }))}
        onValueChange={(value) => {
          const selectedOrg =
            organizations?.find((org) => org.id === value) || null

          setDestinationOrganization(selectedOrg)
        }}
        value={destinationOrganization?.id || ''}
        data-testid="searchOrganizationsAsyncSelect"
      />

      <Button
        disabled={!destinationOrganization}
        onClick={handleTransferClicked}
        className="mt-8"
        variant="critical"
      >
        Transfer
      </Button>
    </>
  )
}

export default AppOrganizationSelectDestinationInput
